export default "__VITE_ASSET__C9jNi6Yh__"